import type { Group } from '../../../access/types';
import { useUserGroupsQuery } from '../../../access/hooks/use-user-groups-query';
import { useSelectedRootLocationConfiguration } from '../use-selected-root-location-configuration';

export const selectIsChecklistAdmin = (
  groups: Group[],
  checklistAdminGroups: string[] | undefined
): boolean => {
  const groupsNames = groups?.map((group) => group.name);
  if (checklistAdminGroups === undefined || checklistAdminGroups.length === 0) {
    return true;
  }
  return checklistAdminGroups.some((value) => groupsNames?.includes(value));
};

export const useIsChecklistAdminQuery = () => {
  const selectedLocation = useSelectedRootLocationConfiguration();
  const checklistAdminGroups = selectedLocation?.checklistAdmins?.filter(
    (value) => value.trim() !== ''
  );

  const { data, isLoading } = useUserGroupsQuery<boolean>((groups) =>
    selectIsChecklistAdmin(groups, checklistAdminGroups)
  );

  return { data, isLoading };
};
